import { render, staticRenderFns } from "./messagePopup.vue?vue&type=template&id=2ff0b304&scoped=true&"
import script from "./messagePopup.vue?vue&type=script&lang=js&"
export * from "./messagePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0b304",
  null
  
)

export default component.exports